import axios from "axios";

/**
 * ==========================================================
 *  AXIOS INSTANCE POUR API SANCTUM
 * ==========================================================
 * Avec cookie-based auth (Laravel Sanctum)
 * ==========================================================
 */
const api = axios.create({
  // baseURL: "http://localhost:8000/api",
  baseURL: "https://api-vdp.bestcentrale.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token'); // Récupération du token (optionnel)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ==========================================================
//  RESPONSE INTERCEPTOR → Auto logout on 401
// ==========================================================
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.dispatchEvent(new CustomEvent("unauthorized"));
    }
    return Promise.reject(error);
  }
);

// ==========================================================
//  API HELPER FUNCTIONS
// ==========================================================

// GET toutes ressources
export const getResources = async (endpoint: string) =>
  api.get(`/${endpoint}`);

// GET ressource par ID
export const getResourceById = async (
  endpoint: string,
  id: string | number,
  extra: string | null = null
) => api.get(`/${endpoint}/${id}${extra ?? ""}`);

// POST avec FormData (upload fichiers ou données simples)
export const postResource = async (
  endpoint: string,
  data: FormData,
  id?: string | number
) => {
  const url = id ? `/${endpoint}/${id}` : `/${endpoint}`;
  return api.post(url, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// PUT pour update (avec ou sans fichier)
export const updateResource = async (
  endpoint: string,
  id: string | number,
  data: any | FormData,
  isFileUpload = false
) => {
  return api.put(`/${endpoint}/${id}`, data, {
    withCredentials: true,
    headers: isFileUpload
      ? { "Content-Type": "multipart/form-data" }
      : {},
  });
};

// DELETE ressource
export const deleteResource = async (endpoint: string, id: string | number) =>
  api.delete(`/${endpoint}/${id}`, { withCredentials: true });

// Télécharger fichier (PDF, Excel, etc.)
export const downloadFile = async (endpoint: string) =>
  api.get(`/${endpoint}`, { responseType: "blob", withCredentials: true });

// Validation d'email ou autre token personnalisé
export const forVerifyEmail = async (
  endpoint: string,
  id: string | number,
  token: string
) => api.get(`/${endpoint}/${id}/${token}`, { withCredentials: true });

// ==========================================================
//  CSRF COOKIE SANCTUM
// ==========================================================
// export const getCsrfCookie = async () => {
//   return axios.get("http://localhost:8000/sanctum/csrf-cookie", {
//     withCredentials: true,
//     headers: {
//       "Content-Type": "application/json",
//       Accept: "application/json",
//     },
//   });
// };

export default api;
